const isGlobal = 'isGlobal';

export const defaultGridViews: Record<string, any[]> = {
  // colar jsons das visões aqui
};

const mergeWithDefaultGridViews = (grids: any = {}): any => {
  const merged = { ...grids };

  Object.keys(defaultGridViews).forEach((gridName) => {
    const currentEntry = merged[gridName] ?? {};
    const views = Array.isArray(currentEntry.views) ? [...currentEntry.views] : [];
    const globalViews = defaultGridViews[gridName] || [];
    const globalViewIds = new Set(globalViews.map((view) => view.viewId));

    // filtra as views que não são globais ou que estão na lista de views globais
    const currentViews = views.filter((view: any) => !view?.[isGlobal] || globalViewIds.has(view.viewId));

    globalViews.forEach((globalView) => {
      const nome = globalView.nome || globalView.name || globalView.viewId;
      const globalViewData = {
        ...globalView,
        name: `⭐ ${nome}`,
        [isGlobal]: true
      };

      const existingIndex = currentViews.findIndex((view: any) => view.viewId === globalView.viewId);

      // se a view global já existe na lista de views, sobrescreve a view com os dados da global
      if (existingIndex >= 0) {
        currentViews[existingIndex] = {
          ...currentViews[existingIndex],
          ...globalViewData
        };
      } else {
        currentViews.unshift(globalViewData);
      }
    });

    merged[gridName] = {
      ...currentEntry,
      views: currentViews
    };
  });

  // remove as views globais que não estão na lista de views globais
  Object.keys(merged).forEach((gridName) => {
    if (!defaultGridViews[gridName]) {
      const entry = merged[gridName];
      if (!entry || !Array.isArray(entry.views)) return;
      entry.views = entry.views.filter((view: any) => !view?.[isGlobal]);
    }
  });

  return merged;
};

// garante que as globais estão na lista de views no localStorage
export const ensureDefaultGridViewsInStorage = (): any => {
  try {
    const raw = localStorage.getItem('grids');
    const current = raw ? JSON.parse(raw) : {};
    const currentSerialized = JSON.stringify(current);
    const merged = mergeWithDefaultGridViews(current);
    const mergedSerialized = JSON.stringify(merged);

    if (currentSerialized !== mergedSerialized) {
      localStorage.setItem('grids', mergedSerialized);
    }

    return merged;
  } catch {
    return {};
  }
};
